import { api } from ".";

const moneyTransferQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    // Legacy synchronous endpoint - keeping for backward compatibility
    createMoneyTransfers: builder.mutation<any, any>({
      query: (moneyTransfer) => ({
        url: "/stripe/money_transfers",
        method: "POST",
        body: moneyTransfer,
      }),
    }),
    // New asynchronous money transfer request endpoints
    createMoneyTransferRequest: builder.mutation<any, any>({
      query: (moneyTransferRequest) => ({
        url: "/stripe/money_transfer_requests",
        method: "POST",
        body: moneyTransferRequest,
      }),
    }),
    getMoneyTransferRequest: builder.query<any, string>({
      query: (requestId) => ({
        url: `/stripe/money_transfer_requests/${requestId}`,
        method: "GET",
      }),
    }),
    getMoneyTransferRequestsByOrder: builder.query<any, string>({
      query: (orderId) => ({
        url: `/stripe/money_transfer_requests/order/${orderId}`,
        method: "GET",
      }),
    }),
    // CLE-2458: distinct cards used to pay the order, for choosing which card to refund on a split
    // payment. Returns an empty list for single-card orders (no choice needed).
    getRefundableCards: builder.query<{ data: IRefundableCard[] }, string>({
      query: (orderId) => ({
        url: `/stripe/orders/${orderId}/refundable-cards`,
        method: "GET",
      }),
    }),
  }),
});

export interface IRefundableCard {
  paymentId: string;
  provider: "STRIPE" | "FINIX";
  brand: string;
  last4: string;
  amountInCents: number;
  depositDate: string;
}

export const {
  useCreateMoneyTransfersMutation,
  useCreateMoneyTransferRequestMutation,
  useGetMoneyTransferRequestQuery,
  useGetMoneyTransferRequestsByOrderQuery,
  useGetRefundableCardsQuery,
} = moneyTransferQueries;
